export const routerWhiteList = [
  '/auth',
  '/reset',
  '/login',
  '/forget',
  '/register',
  '/legal-agreement',
  '/privacy-agreement',
  '/auth-agreement',
  '/activities-promotion',
  '/rev-promotion',
  '/membership-agreement',
  '/data-processing-addendum',
  '/ai-agreement',
]
